<template>
  <v-row>
    <v-col>
      <v-text-field
        label="Händelse/basun"
        outlined
        placeholder=" "
        type="number"
        v-model.number="basun"
        :disabled="disabled"
      />
    </v-col>

    <v-col>
      <v-menu
        ref="datepicker"
        :close-on-content-click="false"
        v-model="datepicker"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :rules="[basun ? validDate : () => true]"
            v-model="date"
            label="Datum"
            readonly
            outlined
            v-bind="attrs"
            v-on="on"
            :disabled="disabled"
          />
        </template>
        <v-date-picker
          locale="sv"
          first-day-of-week="1"
          v-model="date"
          @input="datepicker = false"
          no-title
        />
      </v-menu>
    </v-col>
    <v-col>
      <v-text-field
        type="time"
        label="Tid"
        outlined
        v-model="time"
        :disabled="disabled"
        :rules="[basun ? validTime : () => true]"
      />
    </v-col>
  </v-row>
</template>

<script>
import { format } from 'date-fns'
import { get } from 'vuex-pathify'
import { validDate, validTime } from '@/common/validationRules'

export default {
  name: 'EventBasunFields',

  props: {
    disabled: Boolean
  },

  data: () => ({
    validDate,
    validTime,
    date: null,
    time: null,
    datepicker: false
  }),

  computed: {
    basun_time: get('event/model@basun_time'),

    basun: {
      get() {
        return this.$store.get('event/model@basun')
      },

      set(v) {
        if (v.toString().length === 0) {
          this.$store.set('event/model@basun', null)
        } else {
          this.$store.set('event/model@basun', v)
        }
      }
    }
  },

  created() {
    const timeStart = this.basun_time
    if (!timeStart) return
    this.date = format(new Date(timeStart), 'yyyy-MM-dd')
    this.time = format(new Date(timeStart), 'HH:mm')
  },

  watch: {
    basun(v) {
      if (!v) {
        this.date = null
        this.time = null

        this.$store.set('event/model@basun_time', null)
      }
    },
    date(input) {
      const timeStart = new Date(`${input} ${this.time}`)
      this.$store.set('event/model@basun_time', timeStart)
    },

    time(input) {
      const timeStart = new Date(`${this.date} ${input}`)
      this.$store.set('event/model@basun_time', timeStart)
    }
  }
}
</script>
